import React from "react";
import { fireEvent, render, screen, waitFor } from "@testing-library/react";
import { useTranscripts } from "../../hooks/useTranscripts";
import TranscriptDetail from "./TranscriptDetail";

jest.mock("react-router-dom", () => ({
  ...jest.requireActual("react-router-dom"),
  useParams: () => ({ transcriptId: "42" }),
  Link: ({ children }: { children: React.ReactNode }) => <>{children}</>,
}));

jest.mock("../../../../providers/WorkspaceProvider", () => ({
  useWorkspaceContext: () => ({ workspace: { id: "workspace-1" } }),
}));

jest.mock("../../hooks/useTranscripts");

const mockedUseTranscripts = jest.mocked(useTranscripts);

const failedTranscript = {
  transcript_id: 42,
  title: "Interrupted interview",
  status: "Failed",
  visibility: "Private",
  language: "en-US",
  folder_id: null,
  transcript_text: "Alex: We will resume next week.",
  created_by_user_id: "user-1",
  started_at: "2026-10-15T07:04:51Z",
  ended_at: null,
  duration_seconds: null,
  created_date: "2026-10-15T07:04:51Z",
  modified_date: "2026-10-15T13:04:51Z",
  segments: [
    {
      segment_id: 1,
      sequence_index: 0,
      speaker_label: "Alex",
      text: "We will resume next week.",
      is_final: true,
      created_date: "2026-10-15T07:05:00Z",
    },
  ],
};

describe("TranscriptDetail", () => {
  const completeTranscript = jest.fn();

  beforeEach(() => {
    jest.clearAllMocks();
    completeTranscript.mockResolvedValue({
      ...failedTranscript,
      status: "Completed",
    });
    mockedUseTranscripts.mockReturnValue({
      completeTranscript,
      downloadTranscript: jest.fn(),
      getTranscript: jest.fn().mockResolvedValue(failedTranscript),
      listFolders: jest.fn().mockResolvedValue([]),
      updateTranscript: jest.fn(),
      updateVisibility: jest.fn(),
    } as unknown as ReturnType<typeof useTranscripts>);
  });

  it("offers Save captured text for a failed recording with saved segments", async () => {
    render(<TranscriptDetail />);

    expect(await screen.findByText("Failed")).not.toBeNull();
    fireEvent.click(screen.getByRole("button", { name: "Save captured text" }));

    await waitFor(() =>
      expect(completeTranscript).toHaveBeenCalledWith("workspace-1", 42, {
        transcript_text: "Alex: We will resume next week.",
      }),
    );
    expect(await screen.findByText("Completed")).not.toBeNull();
  });

  it("does not offer a retry action for a failed browser-owned recording", async () => {
    render(<TranscriptDetail />);

    expect(await screen.findByText("Failed")).not.toBeNull();
    expect(screen.queryByRole("button", { name: /retry/i })).toBeNull();
  });
});
